import { ClaimsOptionsInterface, UserAction } from "./types";
import { AllPlans } from "../../types/plan";

export const setPlans = (payload: AllPlans[]) =>
  ({
    type: UserAction.SET_PLANS,
    payload,
  }) as const;

export const setClaimOptions = (payload: ClaimsOptionsInterface) =>
  ({
    type: UserAction.SET_CLAIM_OPTIONS,
    payload,
  }) as const;

export const clearClaimOptions = () =>
  ({
    type: UserAction.CLEAR_CLAIM_OPTIONS,
  }) as const;

export const getPlansByWarrantyName = (payload) =>
  ({
    type: UserAction.GET_PLANS_BY_WARRANTY_NAME,
    payload,
  }) as const;

export const searchPlans = (payload) =>
  ({
    type: UserAction.GET_PLANS_BY_CUSTOMER_INFO,
    payload,
  }) as const;

export const getPlansByUploadInvoice = (payload) =>
  ({
    type: UserAction.GET_PLANS_BY_UPLOAD_INVOICE,
    payload,
  }) as const;

export const fetchOptions = () =>
  ({
    type: UserAction.FETCH_CLAIM_OPTIONS,
  }) as const;
export const fetchAceOptions = (payload) =>
  ({
    type: UserAction.FETCH_ACE_CLAIM_OPTIONS,
    payload,
  }) as const;
export const increaseSearchTry = () =>
  ({
    type: UserAction.INCREASE_PLAN_SEARCH_TRY,
  }) as const;

export const resetSearchTry = () =>
  ({
    type: UserAction.RESET_PLAN_SEARCH_TRY,
  }) as const;

export const fetchPlanById = (payload) =>
  ({
    type: UserAction.GET_PLAN_BY_ID,
    payload,
  }) as const;

export const setUserSearchInfo = (payload) =>
  ({
    type: UserAction.SET_CUSTOMER_SEARCH_INFO,
    payload,
  }) as const;

export const clearUserSearchInfo = () =>
  ({
    type: UserAction.CLEAR_CUSTOMER_SEARCH_INFO,
  }) as const;
